import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { Plann3rStore } from '../../../store/types'

const PagesTab: FC = () => {
  const strings = useSelector(
    (state: Plann3rStore) => state.languages.strings.settings,
  )

  return (
    <div>
      <p className="has-text-centered">{strings.new_tab}</p>
    </div>
  )
}

export default PagesTab
